import { DatePipe } from "@angular/common";
import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Store } from "@ngrx/store";
import { ToasterService } from "angular2-toaster";
import { BsModalRef } from "ngx-bootstrap/modal/modal-options.class";
import "rxjs/add/operator/map";
import "rxjs/add/operator/startWith";
import * as fromRootStore from "../../../reducers";
import { DCService, JobWorkService } from "../../../services/index";

@Component({
  selector: "bit-dc-print",
  templateUrl: "./rgrnbarcodePrint.html",
})
export class rgrnBarcodePrint implements OnInit {
  @Output() partyUpdateEvent = new EventEmitter();
  tabTitle: string;
  tabID: string;
  mode: string;
  @Input() partydata: any = [];
  partyList: any = [];
  list: any = [];
  agentList: any = [];
  designList: any = [];

  printdata: any = {};
  dataList: any = [];
  woDetails: any;
  alphabet: string[];
  predefCol: number;
  userDefCol: number;
  dcList: any = [];
  @Input() set printdt(val: any[]) {
    this.printdata = val;

    this.getDesignList(this.printdata.rgrn_id);
  }

  isLoading: boolean = false;
  @ViewChild("partyForm") partyForm;
  orderfromdtControl: FormControl = new FormControl();
  ordertodtControl: FormControl = new FormControl();
  salesfromdtControl: FormControl = new FormControl();
  salestodtControl: FormControl = new FormControl();
  partyCtrl: FormControl = new FormControl();

  constructor(
    public store: Store<fromRootStore.State>,
    public bsModalRef: BsModalRef,
    public toasterService: ToasterService,
    private dcService: JobWorkService,
    public datePipe: DatePipe
  ) {}

  ngOnInit() {}

  ngAfterViewInit() {
    setTimeout(() => {
      $("#partyname").focus();
    }, 100);
  }

  getDesignList(id) {
    const params = {
      rgrn_id: id,
    };
    let that = this;

    // this.brand = row.brand;
    // let params = {
    //   inw_id: row.inw_id,
    // };
    that.dcService.RgrnModalprint(params).then((res: any) => {
      let temp = [];
      let List = [];
      temp = res.data;
      for (let i = 0; i < temp.length; i++) {
        if (
          Number(temp[i].sf28) > 0 ||
          Number(temp[i].sf30) > 0 ||
          Number(temp[i].sf32) > 0 ||
          Number(temp[i].sf34) > 0 ||
          Number(temp[i].sf34) > 0 ||
          Number(temp[i].sf36) > 0 ||
          Number(temp[i].sf38) > 0 ||
          Number(temp[i].sf40) > 0 ||
          Number(temp[i].sf42) > 0 ||
          Number(temp[i].sf44) > 0 ||
          Number(temp[i].sf46) > 0 ||
          Number(temp[i].sh28) > 0 ||
          Number(temp[i].sh30) > 0 ||
          Number(temp[i].sh32) > 0 ||
          Number(temp[i].sh34) > 0 ||
          Number(temp[i].sh34) > 0 ||
          Number(temp[i].sh36) > 0 ||
          Number(temp[i].sh38) > 0 ||
          Number(temp[i].sh40) > 0 ||
          Number(temp[i].sh42) > 0 ||
          Number(temp[i].sh44) > 0 ||
          Number(temp[i].sh46) > 0
        ) {
          List.push(temp[i]);
        }
      }

      const map = {};
      List.forEach((el) => {
        if (!map[JSON.stringify(el)]) {
          map[JSON.stringify(el)] = true;
          that.dcList.push(el);
        }
        that.calcPieces();
      });
    });

 
  }

  calcPieces() {
    this.dcList.forEach((el) => {
      el.sftot =
      Number(el.sf34) +
        Number(el.sf36) +
        Number(el.sf38) +
        Number(el.sf40) +
        Number(el.sf42) +
        Number(el.sf44) +
        Number(el.sf46);

      el.shtot =
      Number(el.sh34) +
        Number(el.sh36) +
        Number(el.sh38) +
        Number(el.sh40) +
        Number(el.sh42) +
        Number(el.sh44) +
        Number(el.sh46);

      el.bftot =
        Number(el.bf28) +
        Number(el.bf30) +
        Number(el.bf32) +
        Number(el.bf34) +
        Number(el.bf36);
      el.bhtot =
        Number(el.bh28) +
        Number(el.bh30) +
        Number(el.bh32) +
        Number(el.bh34) +
        Number(el.bh36);

      el.tot = Number(el.sftot) + Number(el.shtot);
    });
  }
  print(div) {
    var content = document.getElementById(div).innerHTML;

    var mywindow = window.open("", "Print", "height=850,width=900");

    /*mywindow.document.write('<html><head><title>Print</title>');
    mywindow.document.write('</head><body >');*/
    mywindow.document.write(content);
    //   mywindow.document.write('</body></html>');

    mywindow.document.close();
    mywindow.focus();
    mywindow.print();
    mywindow.close();
    return true;
  }
}



// WEBPACK FOOTER //
// /Users/afsarahamed/Documents/symatis/projects/hyatt-angularweb/src/app/components/Purchase/jobworkorder/rgrnbarcodePrint.ts